import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Button } from './StartPage'
import sparbankenLogo from '../img/logos/sparbanken_logo.png'
import riseLogo from '../img/logos/rise_logo.png'
import regionNorrbottenLogo from '../img/logos/region_norrbotten_logo.svg'

const Wrapper = styled.div`
  padding: 1rem 2vw;
  max-width:35em;

  p {
    text-align: start;
  }
`

const FlexWrapper = styled.div`
  max-width:90vw;
  margin: auto;
  flex-wrap: wrap;
  justify-content: center;
`

const FlexImg = styled.img`
  flex: 1 1 auto;
  min-width: 0;
  margin: 0.3rem 0.3rem;
  
  height: ${props => props.height};
  
  object-fit: contain;
`

const BreakLink = styled.a`
  word-break: break-all;
`

const About = () => {

  return (
    <Wrapper>
      <h2>
        Om
      </h2>
      <p>
        Denna quiz är en del av workshopen och materialet "hashtagjag" som har tagits fram av RISE i ett projekt
        tillsammans med lärare och elever i gymnasieskolan. 
        Här är det möjligt att få närmare kunskaper om några fenomen inom området 
        informationspåverkan samt testa sina kunskaper. 
        Quizen kan användas helt fristående eller som en del av workshopen, 
        som finns att läsa mer om på RISE <a target='_blank' href='https://www.ri.se/sv/vad-vi-gor/projekt/kunnig-pa-natet-spridning-och-utveckling'>projektsida.</a>
      </p>
      <p>
        Workshopen har tagits fram som ett komplement till lärande om källkritik.
        Den utgår från utmaningen att det är svårt att vara motståndskraftig mot 
        illasinnade nätfenomen i sin vardagliga internetanvändning.  
      </p>
      <p>
        Projektet har finansierats av Sparbanken Nord, Region Norrbotten och RISE. 
      </p>
      <FlexWrapper className='flex-row'>
        <FlexImg height='4em' src={sparbankenLogo} alt=""/>
        <FlexImg height='3em' src={riseLogo} alt=""/>
        <FlexImg height='2em' src={regionNorrbottenLogo} alt=""/>
      </FlexWrapper>
      <p className='msb-footnote'>
      <em>
      MSB:s handbok “Informationspåverkan – Handbok för kommunikatörer” ligger till grund 
      för en stor del av materialet: <BreakLink target='_blank' href='https://www.msb.se/sv/publikationer/att-mota-informationspaverkan--handbok-for-kommunikatorer/'>https://www.msb.se/sv/publikationer/att-mota-informationspaverkan--handbok-for-kommunikatorer/</BreakLink> 
      </em>
      </p>
      <p className='msb-footnote'>
      <em>
      Alla emojis är designade av <a target='_blank' href="https://openmoji.org/">OpenMoji</a> - open source-projektet för emojis och ikoner. Licens: <a target='_blank' href="https://creativecommons.org/licenses/by-sa/4.0/#">CC BY-SA 4.0</a>
      </em>
      </p>

    </Wrapper>
  )
}

export default About